/**
 * Simulador del laboratorio en ruta propia (/laboratorio y /laboratorio/:DOCNROXX), como las declaraciones y el informe
 * de inspección: sesión persistida, sin sesión vuelve al inicio. El panel se esconde solo si el backend dice que el
 * simulador no existe en el ambiente (producción responde 404).
 * @author Claude Code (Alexandra Parra) <direccionit.siaco@repremundo.com.co>
 * @since 2026-10-26
 */
import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import Simulabx from "../components/Simulab/Simulabx";
import { getisLoggedIn } from "../libs/redux/slices/authSlice/authSlice";

const SimuladorLaboratorioPage = () => {
  const { DOCNROXX } = useParams();
  const navigate = useNavigate();
  const isLoggedIn = useSelector(getisLoggedIn);
  if (!isLoggedIn) {
    return <Navigate to="/" />;
  }
  return (
    <div className="riodo-escala">
      <Simulabx DOCNROXX={DOCNROXX} onDo={(cDo) => navigate(`/laboratorio/${cDo}`, { replace: true })} />
    </div>
  );
};

export default SimuladorLaboratorioPage;
